// import { EmojiButton } from '@joeattardi/emoji-button';
const { EmojiButton } = require("@joeattardi/emoji-button");

const Emoji = function () {

    const startEmoji = function () {
        console.log('startEmoji');

    const triggers = document.querySelectorAll('.trigger-emoji:not([data-emoji-init]');

    triggers.forEach(trigger => {

        trigger.setAttribute('data-emoji-init', 'true');
        
        const picker = new EmojiButton();        
        const targetSelector = trigger.getAttribute('data-target');

        picker.on('emoji', selection => {
            const el = $(targetSelector)[0];
            if (!el) return; // Garante que o elemento existe no DOM

            const text = el.value;
            const start = el.selectionStart;
            const end = el.selectionEnd;

            // Insere o emoji exatamente na posição do cursor
            el.value = text.substring(0, start) + selection.emoji + text.substring(end);

            setTimeout(() => {
                el.focus();
                // Reposiciona o ponteiro/cursor exatamente após o emoji inserido
                const newCursorPos = start + selection.emoji.length;
                el.setSelectionRange(newCursorPos, newCursorPos);
            }, 10);
        });

        trigger.addEventListener('click', () => picker.togglePicker(trigger));
    });
}

    return {
        init: function () {
            startEmoji();
            // trigger.addEventListener('click', () => picker.togglePicker(trigger))
        }
    }
}();

module.exports = Emoji;
